<template>
  <div class="d-flex justify-content-center pt-5">
    <template v-if="loading">
      <spinner variant="success" />
    </template>
    <div v-else>
      <h4 class="text-center">{{ seconds }}</h4>
      <label v-if="success">
        {{ $t('stripeForm.success-pay-msg') }}
      </label>
      <label v-else>
        Payment process failed
      </label>
    </div>
  </div>
</template>

<script src="./Paid.js"></script>
